import { RootState } from '@/storage/store'
import AceLogo from '@assets/ace-pencil.png'
import { useSelector } from 'react-redux'
import { cn } from '@/common/utilities.ts'
import { TERMS_AND_CONDITIONS_URL } from '@/app/common/constants.ts'

export default function CopyRight() {
  const AuthSessionState = useSelector((state: RootState) => state.AuthSession)

  const currentYear = new Date().getFullYear()
  return (
    <>
      <div
        className={cn(
          'flex text-sm justify-center font-medium items-center gap-1',
          !AuthSessionState.isAuthenticated ? 'flex-col' : ''
        )}
      >
        <div className="flex items-center gap-2 text-sm">
          <img alt="Ace Logo" width="6" src={AceLogo} className="h-auto mb-1" />
          @ {currentYear} ACE Scholarships.
        </div>
        <div className="text-gray-500">Powered by SoftPoint LLC</div>
        <a
          href={TERMS_AND_CONDITIONS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold hover:underline"
        >
          Terms &amp; Conditions
        </a>
      </div>
    </>
  )
}
